import React, { useState, useEffect, useRef } from "react";
import NumberFormat from "react-number-format";
import IconRemove from "../Resources/svg/Icons/IconRemove";
import IconAdd from "../Resources/svg/Icons/IconAdd";

const BoxNumber = ({
  nameVal,
  incrementValue,
  initCounter,
  setValue,
  register,
  verifyMoney,
  validatorInput,
  base = 0,
  financial = false,
  disabled,
}) => {
  const [num, setNum] = useState(initCounter ? initCounter : 1);
  const [coin, setCoin] = useState("$");
  const isFirstRender = useRef(true);

  const handleCLick = (type) => {
    if (financial) {
      if (num >= initCounter && type === "sum") {
        const newValue = num + incrementValue;
        setValue(nameVal, newValue);
        setNum(newValue);
      }
      if (num > base && type === "res") {
        const newValue = num - incrementValue;
        setValue(nameVal, newValue);
        setNum(newValue);
      }
    } else {
      if (num >= initCounter && type === "sum") {
        setValue(nameVal, num + incrementValue);
        setNum(num + incrementValue);
      }
      if (num > initCounter && type === "res") {
        setValue(nameVal, num - incrementValue);
        setNum(num - incrementValue);
      }
    }
  };

  useEffect(() => {
    if (verifyMoney !== undefined) {
      setCoin(verifyMoney === "USD" ? "$" : "S/");
    }
  }, [verifyMoney]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      setNum(initCounter);
      setValue(nameVal, initCounter);
    }
  }, [initCounter]);

  useEffect(() => {
    const minValue = financial ? base : initCounter;

    if (verifyMoney === "USD") {
      if (num < minValue) {
        setNum(minValue);
      }
    }

    if (verifyMoney === "PEN") {
      if (num < minValue) {
        setNum(minValue);
      }
    }
  }, [num, financial, base, initCounter]);

  return (
    <>
      <div className="boxCounter__boxes">
        <div
          className="boxCounter__boxes__wapper"
          id="box_decrement"
          onClick={() => handleCLick("res")}
        >
          <IconRemove
            color={
              num > initCounter || (financial && num > base)
                ? "#4F4FFF"
                : "#A9AFD9"
            }
          />
        </div>
        <NumberFormat
          {...register(nameVal, {
            validate: (value) => validatorInput(value, verifyMoney),
          })}
          name={nameVal}
          className="boxCounter__boxes__wapper-center"
          thousandsGroupStyle="thousand"
          value={num}
          defaultValue={num}
          prefix={coin}
          decimalSeparator="."
          displayType="input"
          type="text"
          thousandSeparator={true}
          allowNegative={false}
          ref={register}
          fixedDecimalScale={true}
          decimalScale={2}
          onValueChange={(values) => {
            const { value } = values;
            setValue(nameVal, Number(value));
            setNum(Number(value));
          }}
        />
        <div
          className="boxCounter__boxes__wapper"
          id="box_increment"
          onClick={() => handleCLick("sum")}
        >
          <IconAdd />
        </div>
      </div>
    </>
  );
};

export default BoxNumber;
